<template>
  <div>
    <div :class="`custom-card custom-card-${this.type}`">
      <div class="left-icon-btn" @click="displaySubTab = !displaySubTab">
        <i class="fa" :class="displaySubTab ? 'fa-minus' : 'fa-plus'"></i>
      </div>
      <div class="card-data">
        <div class="card-column">
          <span>{{ coachs.length }}</span>
          <span>Coachs</span>
        </div>
        <div class="card-column">
          <span>{{ conversionRate }}%</span>
          <span>Conversion</span>
        </div>
      </div>
    </div>

    <div v-if="displaySubTab" :class="`subtab subtab-${this.type}`">
      <el-table :data="coachsSorted" max-height="400">
        <el-table-column label="Nom" prop="name" sortable>
          <template slot-scope="scope">
            <span class="user-link" @click="(e) => goToCoach(e, scope.row.id)">
              {{ scope.row.name }}
            </span>
          </template>
        </el-table-column>

        <el-table-column label="Classement" prop="rank" sortable>
          <template slot-scope="scope">
            {{ scope.row.rank }}
          </template>
        </el-table-column>

        <el-table-column label="Département" prop="department" sortable>
          <template slot-scope="scope">
            {{ scope.row.department.substring(0, 2) }}
          </template>
        </el-table-column>

        <el-table-column
          label="Nombres Séances Découvertes"
          prop="nbDiscoverySessions"
          sortable
        >
          <template slot-scope="scope">
            {{ scope.row.nbDiscoverySessions }}
          </template>
        </el-table-column>

        <el-table-column label="Taux de conversion" prop="tc" sortable>
          <template slot-scope="scope">
            {{ scope.row.tc?.toFixed(2) }}%
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    coachs: {
      type: Array,
      default: () => {
        return [];
      },
    },
    type: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      displaySubTab: false,
    };
  },

  computed: {
    coachsSorted() {
      const sorted = [...this.coachs];

      sorted.sort((a, b) => {
        if (b.tc !== a.tc) {
          return b.tc - a.tc;
        }

        return b.nbDiscoverySessions - a.nbDiscoverySessions;
      });

      // coach rank based on tc value
      let currentRank = 1;
      let sameRankCount = 1;

      sorted.forEach((coach, index) => {
        if (index === 0) {
          coach.rank = currentRank;
        } else if (
          coach.tc === sorted[index - 1].tc &&
          coach.nbDiscoverySessions === sorted[index - 1].nbDiscoverySessions
        ) {
          coach.rank = currentRank;
          sameRankCount++;
        } else {
          currentRank += sameRankCount;
          coach.rank = currentRank;
          sameRankCount = 1;
        }
      });

      return sorted;
    },

    conversionRate() {
      if (this.coachs.length === 0) return 0;
      return (
        this.coachs.reduce((acc, coach) => {
          return acc + parseFloat(coach.tc);
        }, 0) / this.coachs.length
      ).toFixed(2);
    },
  },

  methods: {
    goToCoach(e, id) {
      e.preventDefault();

      const route = this.$router.resolve({
        name: "user-details",
        params: { id },
      });

      window.open(route.href, "_blank");
    },
  },
};
</script>
